import { useCallback, useEffect, useRef } from 'react';
import { useCallbackRef } from './use-callback-ref';

export function useDebounceCallback(callback: () => void, delay: number) {
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = useRef(0);
  useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);
  return useCallback(() => {
    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(handleCallback, delay);
  }, [handleCallback, delay]);
}

// How to use
// import { useDebounceCallback } from '@/hooks/use-debounced-callback';
//
// function MyComponent() {
//   const debouncedCallback = useDebounceCallback(() => {
//     // do something
//   }, 1000);
//
//   return (
//     <button onClick={debouncedCallback}>Click me</button>
//   );
// }
